/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { StorageEnum } from "@malmur-technologies/medicalsystem-shared";
import { getEndISODateTimeRange, getStartISODateTimeRange } from "./date.utils";

/**
 * Checks if a user is currently logged in by verifying the presence of an access token
 * @returns True if an access token exists in local storage, false otherwise
 */
export const isUserLogged = () => {
  return window.localStorage.getItem(StorageEnum.ACCESS_TOKEN_ID) !== null;
};

/**
 * Constructs a query string with start and end date/time range parameters
 * @param startDate - The start date of the range (set to beginning of day)
 * @param endDate - The end date of the range (set to end of day)
 * @returns A query string in the format "?startDateTime=...&endDateTime=..."
 */
export const getRangeDateQuery = (startDate: Date, endDate: Date) => {
  return `?startDateTime=${getStartISODateTimeRange(startDate)}&endDateTime=${getEndISODateTimeRange(endDate)}`;
};

